module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-180x180.0c41986661693b0b554964f0602db965.png";